import { render, staticRenderFns } from "./Modules.vue?vue&type=template&id=0fd5c47c&scoped=true"
import script from "./Modules.vue?vue&type=script&lang=ts"
export * from "./Modules.vue?vue&type=script&lang=ts"
import style0 from "./Modules.vue?vue&type=style&index=0&id=0fd5c47c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fd5c47c",
  null
  
)

export default component.exports